import script from "./leftCard2.vue?vue&type=script&setup=true&lang=js"
export * from "./leftCard2.vue?vue&type=script&setup=true&lang=js"

import "./leftCard2.vue?vue&type=style&index=0&id=1fc37142&scoped=true&lang=scss"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc37142"]])

export default __exports__